"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryProductApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var categoryProductApi = exports.categoryProductApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/productCategory",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/productCategory",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/productCategory/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  remove: function remove(id) {
    return (0, _request.default)({
      url: "/productCategory/".concat(id, "/delete"),
      method: "post"
    });
  }
};